<template>
  <div class="head">
    <p>
      <img v-if="lang ==='zh_cn'" src="../../assets/logo.png" alt="">
      <img v-else src="../../assets/logo_en.png" alt="">
    </p>
<!--    <div class="btn_box" v-if="userType == 2 && path !== '/'">-->
    <div class="btn_box" v-if="path !== '/'">
      <router-link v-if="findRight(6)" to="/allorders" style="display:block;outline: none;"><p :class="path === '/allorders' ? 'btn active' : 'btn'">{{$t('head.allOrder')}}</p></router-link>
<!--      全部订单-->
      <router-link v-if="findRight(1)" to="/newriskmanage" style="display:block;outline: none;"><p :class="path === '/newriskmanage' ? 'btn active' : 'btn'">{{$t('head.applyWind')}}</p></router-link>
      <!--申请风控-->
      <router-link v-if="findRight(2)" to="/financingFundList" style="display:block;outline: none;"><p :class="path === '/financingFundList' ? 'btn active' : 'btn'">{{$t('nav.reseLoan')}}</p></router-link>
<!--      资金锁定-->
      <router-link v-if="findRight(3)" to="/financingExamineList" style="display:block;outline: none;"><p :class="path === '/financingExamineList' ? 'btn active' : 'btn'">{{$t('loanApplication.loanpayment')}}</p></router-link>
<!--      贷款发放-->
      <router-link v-if="findRight(4)" to="/afterLoanList" style="display:block;outline: none;"><p :class="path === '/afterLoanList' ? 'btn active' : 'btn'">{{$t('loanApplication.loanfollow')}}</p></router-link>
<!--      贷后跟踪-->
      <router-link v-if="findRight(5)" to="/poolofmoney" style="display:block;outline: none;"><p :class="path === '/poolofmoney' ? 'btn active' : 'btn'">{{$t('head.poolFunds')}}</p></router-link>
<!--      资金池-->

    </div>

  </div>
</template>
<script>
import {mapState} from 'vuex';
import mixins from '@/helper/mixins.js';
export default {
  name: "Head",
  mixins: [mixins],
  data() {
    return {
      menuLimit:[],
      newFinance: 0,
      path: null,
      lang: window.localStorage.getItem("languageCode") || 'zh_cn'
    };
  },
  computed: {
    ...mapState(['userProfile']),
    userType() {
      return this.userProfile.type;
    },
    loanMenuList() {
      let {loanMenuList} = this.userProfile;
      return Array.isArray(loanMenuList) ? loanMenuList : [];
    },
    // menuLimit() {
    //   let menuLimitList = this.userProfile.menuLimit;
    //   return Array.isArray(menuLimitList) ? menuLimitList : [];
    // }

  },
  watch: {
    $route() {
      this.path = this.$route.path;
      if (this.$route.path !== "/" && !this.isSuper()) {
        this.getMenu().then(data =>{
          this.menuLimit = data;
          // this.$store.commit("SAVE_USER_INFO", Object.assign({}, {menuLimit:data}));
        });
      }
    }
  },

  methods:{
    findRight(menuType) {
      if(this.path == '/'){
        return false;
      }
      if(this.isSuper()){
        return true;
      }
      if(this.menuLimit && this.menuLimit.indexOf(menuType)>-1){
        return true;
      }else{
        return false;
      }
      // let arr = this.loanMenuList.filter(item => item.menuType === menuType);
      // return Array.isArray(arr) && (arr.length) ? arr.some(lts => lts.optType === 1 || [27,28,29].indexOf(lts.optType) >-1) : false;
    }
  },
  mounted() {
    // let _this = this;
    // console.log(this.userProfile.menuLimit);
    // if(this.path !== '/' || !_this.isSuper() ){
    //   _this.getMenu().then(data =>{
    //     this.$store.commit("SAVE_USER_INFO", Object.assign({}, {menuLimit:data}));
    //   });
    // }
  }
};
</script>
<style lang="scss">
  .head{
    .el-badge__content{
      border: none;
    }
  }
</style>
<style lang="scss" scoped>
.head {
  width: 100%;
  height: 100px;
  overflow: hidden;
  display: flex;
  justify-content: space-between;
  img {
    margin-top: 35px;
    height: 30px;
  }
  .btn_box{
    display: flex;
    height: 50px;
    padding-top: 29px;
    .btn {
      cursor: pointer;
      margin-left: 30px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      font-size: 14px;
      color: #fff;
    }
  }
  .active {
    border-bottom: 2px solid #7996F5;
  }
}
</style>
